import { render, staticRenderFns } from "./ShowTab.vue?vue&type=template&id=e8f91476&scoped=true&"
import script from "./ShowTab.vue?vue&type=script&lang=js&"
export * from "./ShowTab.vue?vue&type=script&lang=js&"
import style0 from "./ShowTab.vue?vue&type=style&index=0&id=e8f91476&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f91476",
  null
  
)

export default component.exports